export default {
    header: 'Импорт замечаний',
    imported_remarks_count: 'нет замечаний | {n} замечание | {n} замечания | {n} замечаний',
};
